import React from 'react';

const Step8Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-8">
            Richiedi subito il tuo preventivo online con la detrazione fiscale
            fino al 50%.
        </div>
    );
};

export default Step8Infos;
